import { createApprovalApi } from '@trackly/shared';
import { createAuthenticatedBaseQuery } from '../../utils/createAuthenticatedBaseQuery';
import { getWorkflowsApiBaseUrl } from '../../utils/runtimeConfig';

// Approvals are part of the Workflows service — same base URL.
const apiBaseUrl = getWorkflowsApiBaseUrl();

/**
 * Single Approval API instance for the web client — endpoint definitions live in
 * @trackly/shared (createApprovalApi); only the authenticated baseQuery is web-specific.
 */
export const approvalApi = createApprovalApi(createAuthenticatedBaseQuery(apiBaseUrl, 'Approval API'));
